var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "encryption-field" }, [
    _c("div", { staticStyle: { display: "flex", "align-items": "center" } }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v(_vm._s(_vm.displayValue)),
      ]),
      _vm.hasValue
        ? _c(
            "span",
            {
              staticClass: "iconEye",
              class: { "is-loading": _vm.loading },
              on: { click: _vm.toggleDecrypt },
            },
            [
              _c(
                "el-tooltip",
                { attrs: { placement: "top-start" } },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.completionInformation"))
                    ),
                  ]),
                  _c("svg-icon", { attrs: { "icon-class": _vm.iconType } }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }